import { TextProps } from '@betty/moonlight/lib/common/Text/Text.types';
import { JackpotLabelProps } from './JackpotLabel.types';

export const JackpotTextVariant: Record<
  JackpotLabelProps['imageType'],
  TextProps['variant']
> = {
  square: 'nav-label',
  landscape: 'body-l',
  portrait: 'caption',
  custom: 'caption',
};
